<template>
  <v-row>
    <v-col cols="8" align-self="center">
      <span>{{ label }}</span>
    </v-col>
    <v-col cols="4">
      <v-switch v-model="newValue" color="green" inset />
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

export default {
  props: {
    value: { type: Boolean },
    label: {
      type: String,
      default: null
    },
    filter: {
      type: Object,
      default: null
    }
  },
  setup (props) {
    const newValue = ref(props.value);
    const sideBarFilters = computed(() => store.getters.sideBarFilters);

    watch(newValue, () => {
      if (props.filter.type === 'session') {
        store.commit('setIsSessionFilterApplied', newValue.value);
      }
      const toStore = { ...sideBarFilters.value };

      if (!toStore[props.filter.contentType]) {
        toStore[props.filter.contentType] = {};
      }

      if (props.filter.filterType === 'sessionFieldBased') {
        if (!toStore[props.filter.contentType].session) {
          toStore[props.filter.contentType].session = {};
        }
        if (!toStore[props.filter.contentType].session[props.filter.field]) {
          toStore[props.filter.contentType].session[props.filter.field] = null;
        }
        toStore[props.filter.contentType].session[props.filter.field] = newValue.value ? props.filter.values : [];
      } else {
        if (!toStore[props.filter.contentType][props.filter.field]) {
          toStore[props.filter.contentType][props.filter.field] = null;
        }
        toStore[props.filter.contentType][props.filter.field] = newValue.value;
      }

      store.commit('setSideBarFilters', toStore);
    });

    watch(() => props.value, () => {
      newValue.value = props.value;
    });

    return { newValue };
  }
};
</script>
